<template>
  <div>
    <v-container>
      <v-row class="align-items-center">
        <v-col cols="12" sm="2">
          <v-btn
            :style="showBackButton ? '' : 'visibility:hidden'"
            x-small
            color="default"
            class="mr-4 form-wrapper-back-button"
            @click="emit('back')"
          >{{backButtonText}}</v-btn>
        </v-col>
      </v-row>

      <v-row class="justify-center">
        <span class="overline">Passo <span class="current-step">{{currentStep}}</span> de <span class="total-steps">{{totalSteps}}</span></span>
      </v-row>
    </v-container>
    <slot></slot>
    <v-container>
      <v-row>
        <v-col>
          <v-btn
            v-if="showNextButton"
            color="success"
            class="mr-4 wrapper-next-button"
            @click="emit('next')"
          >{{nextButtonText}}</v-btn>
          <v-btn
            v-if="showFinishButton"
            color="success"
            class="mr-4 wrapper-finish-button"
            @click="emit('finish')"
          >{{finishButtonText}}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: function() {
    return {};
  },
  props: {
    showBackButton: {
      type: Boolean,
      required: false,
      default: true
    },
    backButtonText: {
      type: String,
      required: false,
      default: 'Voltar'
    },
    showNextButton: {
      type: Boolean,
      required: false,
      default: true
    },
    nextButtonText: {
      type: String,
      required: false,
      default: 'Próximo'
    },
    showFinishButton: {
      type: Boolean,
      required: false,
      default: false
    },
    finishButtonText: {
      type: String,
      required: false,
      default: 'Finalizar'
    },
    currentStep: {
      type: String | Number,
      required: false,
      default: ''
    },
    totalSteps: {
      type: String | Number,
      required: false,
      default: ''
    }
  },
  methods: {
    emit(event) {
      this.$emit(event);
    }
  }
};
</script>

<style>
</style>